import { Branch, HorizontalLine } from './styled';
export function TreeBranch() {
    return (<Branch>
      <HorizontalLine />
    </Branch>);
}
